@if (categoryEmptyData(); as categoryEmpty) {
  <div class="no-item">
    <img
      class="icon"
      [src]="imgSrc()"
      [alt]="categoryEmpty.text | translate" />
    <p class="text">
      {{ categoryEmpty.text | translate }}
    </p>
  </div>
}
